import axios from 'axios'

const API_ROOT = window.__PRERENDER_INJECTED ? window.__PRERENDER_INJECTED.API_URL : '/api/v1/'

const config = {
  baseURL: API_ROOT
}

const HTTP = axios.create(config)

export default {
  get: (endpoint, options = {}) => {
    return HTTP.get(endpoint, options).then((response) => {
      return response.data
    })
  },
  post: (endpoint, data = {}, options = {}) => {
    return HTTP.post(endpoint, data, options)
      .then(response => response)
      .catch((error) => {
        return error.response
      })
  },
  patch: (endpoint, data = {}, options = {}) => {
    return HTTP.patch(endpoint, data, options)
      .then(response => response)
      .catch((error) => {
        return error.response
      })
  },
  delete: (endpoint, data = {}, options = {}) => {
    return HTTP.delete(endpoint, data, options)
      .then(response => response)
      .catch((error) => {
        return error.response
      })
  }
}



// WEBPACK FOOTER //
// ./src/api.js